import styled from "styled-components";


export const DevicesMapWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 80;

    border: 1px solid rgba(60, 140, 220, 0.35);
    border-radius: 6px;
    box-shadow: inset 0 0 12px rgba(30, 110, 200, 0.08), 0 0 8px rgba(20, 90, 180, 0.12);
    box-sizing: border-box;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 90% 100%, 81% 93.5%, 21% 93.5%, 12% 100%, 0 100%);
    overflow: hidden;

    &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 16px;
        height: 16px;
        border-top: 1px solid #4096ff;
        border-left: 1px solid #4096ff;
        border-radius: 4px 0 0 0;
    }
    & .corner-br {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 16px;
        height: 16px;
        border-bottom: 1px solid #4096ff;
        border-right: 1px solid #4096ff;
        border-radius: 0 0 6px 0;
    }

    .amap-info-content {
        background-color: rgba(0, 0, 0, 0.5);
        padding-right: 10px;
        z-index: 200;
    }

    .amap-info-sharp {
        border-top: 8px solid rgba(0, 0, 0, 0.2);
    }
`;
